function MinuteSelector({
  className,
  disabled,
  onChange,
  value,
}: {
  className?: string;
  disabled?: boolean;
  onChange: (minute: number) => void;
  value?: number;
}) {
  let minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

  // If we have a valid value that isn't in our array, add it.
  if (value !== undefined && value < 60 && value >= 0 && !minutes.includes(value)) {
    minutes.push(value);
    minutes.sort((a, b) => a - b);
  }

  return (
    <select
      className={`cursor-pointer focus:z-50 ${className ? className : ""} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      disabled={disabled}
      onChange={(e) => onChange(parseInt(e.target.value))}
      value={value}
    >
      {!value && <option value="">--</option>}
      {minutes.map((minute) => (
        <option key={minute} value={minute}>
          {minute.toString().padStart(2, "0")}
        </option>
      ))}
    </select>
  );
}

export default MinuteSelector;
